interface SettingsSaveBarProps {
  dirty: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

export default function SettingsSaveBar({
  dirty,
  onSave,
  onDiscard,
}: SettingsSaveBarProps) {
  return (
    <div className="sticky bottom-4 z-30">
      <div
        className={`flex flex-col sm:flex-row sm:items-center gap-3 px-4 py-3.5 rounded-card border transition-colors ${
          dirty
            ? "bg-background-50 border-primary-200 shadow-dropdown"
            : "bg-background-50/90 border-background-200"
        }`}
      >
        <div className="flex items-center gap-2.5 flex-1 min-w-0">
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${
              dirty ? "bg-accent-100 text-accent-600" : "bg-secondary-100 text-secondary-600"
            }`}
          >
            <i
              className={`${
                dirty ? "ri-edit-2-line" : "ri-checkbox-circle-line"
              } text-base`}
            ></i>
          </div>
          <p className="text-sm font-semibold text-foreground-700">
            {dirty
              ? "لديك تغييرات غير محفوظة"
              : "جميع التغييرات محفوظة"}
          </p>
        </div>

        <div className="flex items-center gap-2.5 shrink-0">
          <button
            type="button"
            onClick={onDiscard}
            disabled={!dirty}
            className="h-11 px-4 rounded-btn border border-background-300 text-foreground-700 text-sm font-bold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          >
            تجاهل التغييرات
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={!dirty}
            className="h-11 px-6 rounded-btn bg-primary-500 text-white text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span className="inline-flex items-center gap-2">
              <i className="ri-save-3-line text-lg"></i>
              حفظ التغييرات
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}